export default __webpack_public_path__ + "assets/front/scss/affichage-timeline.320c7ad6a888e06574feab001d56198f.css";